module.exports = require("dom-helpers/query/contains");


//////////////////
// WEBPACK FOOTER
// external "dom-helpers/query/contains"
// module id = 10
// module chunks = 0